import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLayerGroup,
    faBoxOpen,
    faTrash,
    faTimes,
    faSync,
} from '@fortawesome/free-solid-svg-icons';

const BulkToolbar = ({
    selectedSets,
    filteredSets,
    isBulkOpening,
    isBulkRemoving,
    onSelectAll,
    onDeselectAll,
    onBulkOpen,
    onBulkRemoveRequest,
    onExit,
}) => (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-blue-200 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
            {/* Left: count + select/deselect */}
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center shadow-sm">
                        <FontAwesomeIcon icon={faLayerGroup} className="text-white text-sm" />
                    </div>
                    <span className="font-semibold text-gray-800 text-sm sm:text-base whitespace-nowrap">
                        {selectedSets.size} set{selectedSets.size !== 1 ? 's' : ''} selected
                    </span>
                </div>
                <button
                    onClick={onSelectAll}
                    disabled={selectedSets.size === filteredSets.length}
                    className="text-xs sm:text-sm px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 rounded-lg font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                >
                    Select All ({filteredSets.length})
                </button>
                {selectedSets.size > 0 && (
                    <button
                        onClick={onDeselectAll}
                        className="text-xs sm:text-sm px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-600 border border-gray-200 rounded-lg font-medium transition-colors whitespace-nowrap"
                    >
                        Deselect All
                    </button>
                )}
            </div>

            {/* Right: actions */}
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                {selectedSets.size > 0 && (
                    <>
                        <button
                            onClick={onBulkOpen}
                            disabled={isBulkOpening}
                            className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-400 text-white text-sm font-semibold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap"
                        >
                            {isBulkOpening ? (
                                <>
                                    <FontAwesomeIcon icon={faSync} className="animate-spin" />
                                    <span>Opening...</span>
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faBoxOpen} />
                                    <span>Mark All Opened</span>
                                </>
                            )}
                        </button>

                        <button
                            onClick={onBulkRemoveRequest}
                            className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap"
                        >
                            <FontAwesomeIcon icon={faTrash} />
                            <span>Remove ({selectedSets.size})</span>
                        </button>
                    </>
                )}

                <button
                    onClick={onExit}
                    className="flex items-center gap-2 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-semibold rounded-xl transition-all duration-200 whitespace-nowrap"
                >
                    <FontAwesomeIcon icon={faTimes} />
                    <span>Exit</span>
                </button>
            </div>
        </div>
    </div>
);

export default BulkToolbar;
